<div class="form-group">
  <label class="form-label" [htmlFor]="fieldName">{{ label }}</label>
  <textarea
    [name]="fieldName"
    [id]="fieldName"
    class="form-control"
    [value]="value"
    (input)="onChange($event)"
    (blur)="onTouched()"
    [disabled]="disabled"
    [ngClass]="{
      'is-invalid': formField && formField.touched && formField.errors
    }"
  ></textarea>
  @if (formField && formField.touched && formField.errors) {
    <div
      class="invalid-feedback"
      >
      @if (formField.hasError('required')) {
        <div>
          <small>{{ label }} is required</small>
        </div>
      }
      @if (formField.hasError('email')) {
        <div>
          <small>{{ label }} is invalid</small>
        </div>
      }
      @if (formField.hasError('pattern')) {
        <div>
          <small
            >{{ label }} must include an uppercase, a lowercase, a number and a
            symbol</small
            >
          </div>
        }
      </div>
    }
  </div>
